import { RouteConfig } from 'vue-router';
import { INavigationExtraItems } from '@/api/types/revenue';
import { routes } from '@/router';
import store from '@/store/index';
import { USER_ROLES } from '@/mappings/user-roles';
import { isRouteDeniedForRoles } from '@/mappings/role-restrictions';

const getUserRoles = (): string[] => store.getters['authModule/GET_USER']?.roles ?? [];

export const hasRole = (role: USER_ROLES): boolean => getUserRoles().includes(role);

// маршрут закрыт для одной из ролей пользователя, см. DENIED_ROUTES_BY_ROLE
export const isRouteDenied = (routeName?: string | null): boolean =>
    isRouteDeniedForRoles(routeName, getUserRoles());

export const canEditOffers = (): boolean => !hasRole(USER_ROLES.NEW_AFFILIATE_MANAGER);

export const checkRole = (inspectingRoutes: INavigationExtraItems[]): INavigationExtraItems[] => {
    const allRoutes = collectAllRoutes(routes);
    const routesWithRoles = allRoutes.filter(item => item.meta?.hasOwnProperty('roles'));
    inspectingRoutes.forEach((item:INavigationExtraItems) => {
        if (isRouteDenied(item.routeName)) {
            item.show = false;
            return;
        }
        const currentRoute = routesWithRoles.find(route => route.name === item.routeName);
        item.show = currentRoute ?
            currentRoute.meta!.roles!.some((role) => getUserRoles().includes(role)) :
            !!item.routeName;
    });
    return inspectingRoutes;
};

const collectAllRoutes = (routes: RouteConfig[]): RouteConfig[] => {
    const parentRoutes = routes.filter(item => item.hasOwnProperty('meta') && item.hasOwnProperty('name'));
    const childRoutes = routes.reduce((acc: RouteConfig[], item: RouteConfig) => {
        if (item.hasOwnProperty('children')) {
            const items = collectAllRoutes(item.children!);
            return [ ...acc, ...items ];
        } else {
            return [ ...acc ];
        }
    }, []);

    return [ ...parentRoutes, ...childRoutes];
};
